var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonTypeVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 86.8996C2 88.4996 3.3 89.7996 4.9 89.7996H21.5V84.0996H4.9C3.3 84.0996 2 85.2996 2 86.8996Z",
    fill: "#4EA8DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1 84.0996H34.8V89.7996H94.1C95.7 89.7996 97 88.4996 97 86.8996C97 85.2996 95.7 84.0996 94.1 84.0996Z",
    fill: "#4EA8DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2001 79C26.6001 79 25.3 80.3 25.3 81.9V92C25.3 93.6 26.6001 94.9 28.2001 94.9C29.8001 94.9 31.1 93.6 31.1 92V81.9C31.0001 80.3 29.7001 79 28.2001 79Z",
    fill: "#4EA8DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 6H7.5C4.5 6 2 8.4 2 11.4V70.1C2 73.1 4.5 75.6 7.5 75.6H91.5C94.5 75.6 97 73.1 97 70.1V11.4C97 8.4 94.5 6 91.5 6ZM91.3 69.9H7.7V11.7H91.3V69.9Z",
    fill: "#4EA8DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5001 62.7004C61.6001 62.7004 71.4001 52.9004 71.4001 40.8004C71.4001 28.7004 61.6001 18.9004 49.5001 18.9004C37.4001 18.9004 27.6001 28.7004 27.6001 40.8004C27.6001 52.9004 37.4001 62.7004 49.5001 62.7004ZM43.3001 32.2004C43.3001 30.9004 44.8001 30.1004 45.9001 30.8004L58.8001 39.4004C59.8001 40.1004 59.8001 41.5004 58.8001 42.2004L45.9001 50.8004C44.8001 51.5004 43.3001 50.7004 43.3001 49.4004V32.2004Z",
    fill: "#4EA8DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonTypeVideo);
export default __webpack_public_path__ + "static/media/lesson_type_video.4b5e2d9f991da2549a9d30d8d11cf49a.svg";
export { ForwardRef as ReactComponent };